import { Button, Card } from '@meshhub/design-tokens/ui';
import { ShieldAlert } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { S } from '../lib/strings.js';

/**
 * Shown when a USER navigates directly to an admin route.
 *
 * A blank page or a silent redirect would leave someone guessing whether the
 * app is broken; this says plainly what happened and offers the way back.
 */
export function Forbidden() {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen items-center justify-center p-6">
      <Card className="flex max-w-lg flex-col items-center gap-4 text-center">
        <ShieldAlert size={32} className="text-warning" aria-hidden="true" />
        <h1 className="text-lg font-bold">{S.auth.forbiddenTitle}</h1>
        <p className="text-base text-text-muted">{S.auth.forbiddenHint}</p>
        <Button variant="primary" onClick={() => navigate('/')}>
          {S.auth.backToContacts}
        </Button>
      </Card>
    </div>
  );
}
